import { useNavigate } from 'react-router-dom';
import DiagnosticsView from '@/components/DiagnosticsView';

/**
 * Standalone /observability page — wraps DiagnosticsView. The same
 * component is also embedded inside Mission Control's DIAGNOSTICS tab,
 * so this URL is a deep link for whoever (Carter, an alert link)
 * wants to skip Mission Control's other panels.
 */
export default function ObservabilityPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-jarvis-deep-dark text-white font-mono">
      <header className="border-b border-jarvis-blue/15 px-6 py-3 flex items-center gap-4">
        <button
          onClick={() => navigate('/')}
          className="text-[10px] tracking-widest text-jarvis-blue/70 hover:text-jarvis-blue transition"
        >
          ← BACK
        </button>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-jarvis-blue animate-pulse rounded-full" />
          <h1 className="text-xs tracking-[0.4em] text-jarvis-blue">
            J.A.R.V.I.S. / OBSERVABILITY
          </h1>
        </div>
        <button
          onClick={() => navigate('/mission')}
          className="ml-auto text-[10px] tracking-widest text-jarvis-blue/70 hover:text-jarvis-blue transition"
        >
          MISSION CONTROL →
        </button>
      </header>
      <div className="px-6 py-6 max-w-6xl mx-auto">
        <DiagnosticsView />
      </div>
    </div>
  );
}
